import { useRegister } from "@src/queries";
import { RegisterCard, BrandLogo, useAppMessage } from "@repo/ui";
import { useNavigate, useSearchParams } from "react-router";

export default function RegisterPage() {
    const navigate = useNavigate();
    const [params] = useSearchParams();

    const notify = useAppMessage();

    const redirect = params.get("redirect") ?? "/";
    const initialEmail = params.get("email") ?? "";
    const initialName = params.get("name") ?? "";

    const { mutateAsync, isPending } = useRegister({
        autoLogin: true, // залогинить сразу после регистрации
        onSuccess: () => {
            notify.success("Аккаунт создан!");
            navigate(redirect, { replace: true });
        },
        onError: (err) => {
            notify.apiError(err);
        },
    });

    async function handleSubmit(values: { name: string; email: string; password: string }) {
        await mutateAsync(values);
    }

    return (
        <div
            style={{
                minHeight: "100vh",
                display: "grid",
                placeItems: "center",
                padding: 24,
            }}
        >
            <RegisterCard
                logo={<BrandLogo src="/icon.svg" text="Optim S" height={40} />}
                onSubmit={handleSubmit}
                loading={isPending}
                initialName={initialName}
                initialEmail={initialEmail}
                signInHref="/login"
            />
        </div>
    );
}
